<template>
    <div class="d-flex">
        <div>
            {{ serverInfoComputed.footerLeft }}
            {{ $t("components.appLayout.footer.version", { version: serverInfoComputed.version, build: serverInfoComputed.buildNumber }) }}
        </div>
        <div class="ml-auto">{{ serverInfoComputed.footerRight }}</div>
    </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";

export default defineComponent({
    components: {},
    setup() {
        const store = useStore();
        const serverInfoComputed = computed(() => store.state.resource.server.info);
        return { serverInfoComputed };
    },
});
</script>